import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Function to handle anchor links properly
  const getServicesLink = () => {
    // If we're on the home page, just use the hash
    if (location.pathname === '/') {
      return '#services';
    }
    // If we're on a different page, go to home and then to the services section
    return '/#services';
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          <img src="/images/logo.png" alt="Holistic Holidays Logo" className="nav-logo-img" />
          <span className="logo-text">Holistic Holidays LLP</span>
        </Link>

        <div className="menu-icon" onClick={toggleMenu}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>

        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          {/* <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setIsOpen(false)}>
              Home
            </Link>
          </li> */}
          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={() => setIsOpen(false)}>
              About Us
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/destinations" className="nav-link" onClick={() => setIsOpen(false)}>
              Destinations
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/packages" className="nav-link" onClick={() => setIsOpen(false)}>
              Packages
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/gallery" className="nav-link" onClick={() => setIsOpen(false)}>
              Gallery
            </Link>
          </li>
          <li className="nav-item">
            <Link to={getServicesLink()} className="nav-link" onClick={() => setIsOpen(false)}>
              Services
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link contact-btn" onClick={() => setIsOpen(false)}>
              Enquire Now
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar; 